<mat-toolbar>

  <span class="spacer"></span>

  <a mat-flat-button
     routerLink="../../screening"
     aria-label="Open Settings dialog"
  >
    <mat-icon>tune</mat-icon>
    <span>Back to Screening</span>
  </a>
</mat-toolbar>
<div class="db-overview">
  <h2>Screening Evaluation</h2>
  <p>
    Of the {{ papers().length }} identified articles, we found {{ processes().length }} screenings. <br>
    {{ llmScreeningOneAuditedCount }}, and {{ manualScreeningOneCount }} title and abstracts were screened manually and
    with an LLM,
    respectively. <br>
    Of those  {{ llmScreeningTwoAuditedCount }} and  {{ manualScreeningTwoCount }} articles were included for full text
    screening manually and by the LLM, respectively. <br>
    Consequently {{ manualScreeningTwoCount }} were manually included and {{ llmScreeningTwoPassedCount }} were included
    by the LLM. <br>
    In these evaluation diagrams, you can see the similarity between articles recorded manually and those recorded using
    LLM.
  </p>
</div>
@if (metrics().length) {
  <mat-form-field>
    <mat-label>Metric</mat-label>
    <mat-select [value]="selectedMetric()" (selectionChange)="selectedMetric.set($event.value)">
      @for (metricsName of metricsNames; track $index) {
        <mat-option [value]="metricsName">{{ metricsName }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <app-info-card class="metric-hint" size="SMALL" [marginTop]="true" [title]="selectedMetric()">
    <span subtitle>
       {{ metricDescriptions[selectedMetric()] }}
    </span>
  </app-info-card>
  <div class="echarts" echarts [options]="chartOption()"></div>

} @else {
  <app-empty-state
    title="No screening metrics found"
    subtitle="Set a 'Manual Screening result' for each paper and ensure each paper has been audited through both Title/Abstract screening and Full-Text screening"
  >
  </app-empty-state>
}
